<app-admin-pharmacies-list />
